(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["solacely-cart-drawer"] && !Shopify.designMode) return;
  try {
    // Reference-counted scroll lock. Defined here because the cart drawer is the
  // first consumer; the theme's other modals still write body.style.overflow
  // directly and can migrate to this one call site at a time.
  window.SolacelyScrollLock = window.SolacelyScrollLock || (function () {
    var depth = 0;
    var savedY = 0;
    // iOS Safari ignores overflow:hidden for touch scrolling, so the body has to
    // be pinned. Only on touch devices - pinning on desktop would shift the page.
    var needsPin = window.matchMedia('(hover: none) and (pointer: coarse)').matches;

    return {
      lock: function () {
        depth += 1;
        if (depth > 1) return;
        savedY = window.pageYOffset || document.documentElement.scrollTop || 0;
        document.body.style.overflow = 'hidden';
        if (!needsPin) return;
        document.body.style.position = 'fixed';
        document.body.style.top = -savedY + 'px';
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
      },
      unlock: function () {
        if (depth === 0) return;
        depth -= 1;
        if (depth > 0) return;
        document.body.style.overflow = '';
        if (!needsPin) return;
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
        window.scrollTo(0, savedY);
      },
    };
  })();

  (function () {
    var backdrop = document.getElementById('cart-drawer-backdrop');
    var drawer = document.getElementById('cart-drawer');
    var closeBtn = document.getElementById('cart-drawer-close');
    var itemsEl = document.getElementById('cart-drawer-items');
    var errorEl = document.getElementById('cart-drawer-error');
    var defaultCartError = errorEl ? errorEl.getAttribute('data-i18n-generic-error') : '';
    var cartRequestInFlight = false;
    var currentCart = null;
    var emptyEl = document.getElementById('cart-drawer-empty');
    var footerEl = document.getElementById('cart-drawer-footer');
    var subtotalEl = document.getElementById('cart-drawer-subtotal');
    var countEl = document.getElementById('cart-drawer-count');
    var template = document.getElementById('cart-drawer-item-template');
    var certificateForTemplate = itemsEl.getAttribute('data-i18n-certificate-for');

    var progressEl = document.getElementById('cart-progress');
    var progressFill = document.getElementById('cart-progress-fill');
    var shippingMilestone = document.getElementById('cart-progress-milestone-shipping');
    var shippingLabel = document.getElementById('cart-progress-shipping-label');
    var shippingAmount = document.getElementById('cart-progress-shipping-amount');
    var shippingDot = document.getElementById('cart-progress-dot-shipping');
    var giftMilestone = document.getElementById('cart-progress-milestone-gift');
    var giftLabel = document.getElementById('cart-progress-gift-label');
    var giftAmount = document.getElementById('cart-progress-gift-amount');
    var giftDot = document.getElementById('cart-progress-dot-gift');

    var recommendationsEl = document.getElementById('cart-drawer-recommendations');
    var recommendationsList = document.getElementById('cart-drawer-recommendations-list');
    var recommendationTemplate = document.getElementById('cart-drawer-recommendation-template');
    var recommendationAddToCartText = recommendationsEl ? recommendationsEl.getAttribute('data-i18n-add-to-cart') : '';
    var recommendationSoldOutText = recommendationsEl ? recommendationsEl.getAttribute('data-i18n-sold-out') : '';

    var freeCardEl = document.getElementById('cart-drawer-free-card');
    var freeCardAddBtn = document.getElementById('cart-drawer-free-card-add');
    var freeCardVariantId = freeCardEl ? Number(freeCardEl.getAttribute('data-variant-id')) : 0;
    var freeCardRemoving = false;

    if (!drawer || !backdrop || !template) return;

    var shippingThreshold = parseInt(progressEl.getAttribute('data-free-shipping-threshold'), 10) || 0;
    var giftThreshold = parseInt(progressEl.getAttribute('data-free-gift-threshold'), 10) || 0;
    var i18n = {
      shippingLabel: progressEl.getAttribute('data-i18n-shipping-label'),
      shippingRemaining: progressEl.getAttribute('data-i18n-shipping-remaining'),
      shippingAchieved: progressEl.getAttribute('data-i18n-shipping-achieved'),
      giftLabel: progressEl.getAttribute('data-i18n-gift-label'),
      giftRemaining: progressEl.getAttribute('data-i18n-gift-remaining'),
      giftAchieved: progressEl.getAttribute('data-i18n-gift-achieved'),
    };

    // The locale strings keep their "{{ amount }}" placeholder literally (the
    // `t` filter only substitutes named args). Shopify bundles this script into
    // compiled_assets/snippet-scripts.js WITHOUT running Liquid on it, so a
    // raw tag would ship verbatim there, while a bare double-brace would be
    // rendered away in the inline fallback - so build the string from parts.
    var amountPlaceholder = '{' + '{ amount }' + '}';

    var lastRecommendationsKey = null;
    var recommendationsRequestId = 0;
    var pendingRecommendationItems = null;

    function openDrawer() {
      // Guarded so repeat opens (e.g. two fetchCart().then(openDrawer) calls)
      // can't double-increment the scroll lock's depth counter.
      var wasOpen = drawer.classList.contains('is-open');
      drawer.classList.add('is-open');
      backdrop.classList.add('is-visible');
      drawer.setAttribute('aria-hidden', 'false');
      if (!wasOpen) window.SolacelyScrollLock.lock();
      if (closeBtn) closeBtn.focus();
      // The drawer is hidden at page load, and currency converters skip
      // non-visible nodes on their initial pass - re-scan now that it's on
      // screen, or the prices stay in the store's base currency.
      window.SolacelyMoney.refresh(drawer);
      // Recommendations are deferred until the drawer is actually opened.
      if (pendingRecommendationItems) renderRecommendations(pendingRecommendationItems);
    }

    function closeDrawer() {
      // Reachable from the X, the backdrop, Escape, two "continue shopping"
      // buttons and (later) a swipe - must be idempotent or the lock depth drifts.
      if (!drawer.classList.contains('is-open')) return;
      clearError();
      drawer.classList.remove('is-open');
      backdrop.classList.remove('is-visible');
      drawer.setAttribute('aria-hidden', 'true');
      window.SolacelyScrollLock.unlock();
    }

    function renderProgress(cartTotal) {
      if (!progressEl) return;

      if (shippingThreshold <= 0 && giftThreshold <= 0) {
        progressEl.hidden = true;
        return;
      }
      progressEl.hidden = false;

      var maxThreshold = Math.max(shippingThreshold, giftThreshold);
      var fillPct = maxThreshold > 0 ? Math.min((cartTotal / maxThreshold) * 100, 100) : 0;
      progressFill.style.width = fillPct + '%';

      if (shippingThreshold > 0) {
        var shippingPos = maxThreshold > 0 ? Math.min((shippingThreshold / maxThreshold) * 100, 100) : 0;
        var shippingAchieved = cartTotal >= shippingThreshold;
        shippingMilestone.hidden = false;
        shippingDot.hidden = false;
        shippingDot.style.left = shippingPos + '%';
        shippingDot.classList.toggle('is-achieved', shippingAchieved);
        shippingMilestone.style.left = shippingPos + '%';
        shippingLabel.textContent = i18n.shippingLabel;
        if (shippingAchieved) {
          shippingAmount.textContent = i18n.shippingAchieved;
        } else {
          window.SolacelyMoney.renderInto(
            shippingAmount,
            i18n.shippingRemaining,
            amountPlaceholder,
            shippingThreshold - cartTotal
          );
        }
      } else {
        shippingMilestone.hidden = true;
        shippingDot.hidden = true;
      }

      if (giftThreshold > 0) {
        var giftPos = maxThreshold > 0 ? Math.min((giftThreshold / maxThreshold) * 100, 100) : 0;
        var giftAchieved = cartTotal >= giftThreshold;
        giftMilestone.hidden = false;
        giftDot.hidden = false;
        giftDot.style.left = giftPos + '%';
        giftDot.classList.toggle('is-achieved', giftAchieved);
        giftMilestone.style.left = giftPos + '%';
        giftLabel.textContent = i18n.giftLabel;
        if (giftAchieved) {
          giftAmount.textContent = i18n.giftAchieved;
        } else {
          window.SolacelyMoney.renderInto(
            giftAmount,
            i18n.giftRemaining,
            amountPlaceholder,
            giftThreshold - cartTotal
          );
        }
      } else {
        giftMilestone.hidden = true;
        giftDot.hidden = true;
      }
    }

    function renderRecommendations(items) {
      if (!recommendationsEl || !recommendationsList || !recommendationTemplate) return;

      if (!items.length) {
        recommendationsEl.hidden = true;
        lastRecommendationsKey = null;
        return;
      }

      var cartProductIds = items.map(function (item) { return item.product_id; });

      // Key on the whole set of products in the cart. The old guard used
      // items[0].product_id, so removing or reordering the first line refetched
      // for no reason.
      var key = cartProductIds.slice().sort().join(',');
      if (key === lastRecommendationsKey) return;
      lastRecommendationsKey = key;

      // fetchCart() runs on every page load, so fetching here would cost a
      // ~1.1s request on every page for anyone with a cart. Wait for the drawer
      // to actually be opened.
      if (!drawer.classList.contains('is-open')) {
        pendingRecommendationItems = items;
        lastRecommendationsKey = null;
        return;
      }
      pendingRecommendationItems = null;

      var requestId = ++recommendationsRequestId;
      var productId = items[0].product_id;

      fetch('/recommendations/products.json?product_id=' + productId + '&limit=6&intent=related')
        .then(function (res) { return res.json(); })
        .then(function (data) {
          // A newer render started while this was in flight - drop the stale result.
          if (requestId !== recommendationsRequestId) return;

          var products = (data.products || []).filter(function (product) {
            return cartProductIds.indexOf(product.id) === -1;
          });

          recommendationsList.innerHTML = '';

          if (!products.length) {
            recommendationsEl.hidden = true;
            return;
          }

          products.slice(0, 6).forEach(function (product) {
            var node = recommendationTemplate.content.cloneNode(true);
            var link = node.querySelector('.cart-drawer-recommendation__link');
            var img = node.querySelector('.cart-drawer-recommendation__image img');
            var titleEl = node.querySelector('.cart-drawer-recommendation__title');
            var addBtn = node.querySelector('[data-add-recommendation]');

            link.href = product.url;
            if (product.featured_image) {
              img.src = product.featured_image;
              img.alt = product.title;
            }
            titleEl.textContent = product.title;

            var variant = (product.variants || []).find(function (v) { return v.available; });
            addBtn.textContent = variant ? recommendationAddToCartText : recommendationSoldOutText;

            if (!variant) {
              addBtn.disabled = true;
            } else {
              addBtn.addEventListener('click', function () {
                addBtn.disabled = true;
                fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                  body: JSON.stringify({ id: variant.id, quantity: 1 }),
                })
                  .then(function (res) {
                    if (!res.ok) return Promise.reject(res);
                    return fetchCart();
                  })
                  .catch(function () { addBtn.disabled = false; });
              });
            }

            recommendationsList.appendChild(node);
          });

          recommendationsEl.hidden = false;
        })
        .catch(function () {
          if (requestId !== recommendationsRequestId) return;
          recommendationsEl.hidden = true;
          // Clear the key so a transient network failure doesn't leave the rail
          // permanently suppressed for this cart.
          lastRecommendationsKey = null;
        });
    }

    // Offer the free card only when the rest of the cart is worth something and
    // the card isn't in it yet. If the card is all that's left, take it out so
    // nobody checks out with just the freebie.
    function renderFreeCard(cart) {
      if (!freeCardEl) return;

      var cardLines = cart.items.filter(function (i) { return i.variant_id === freeCardVariantId; });
      var otherLines = cart.items.filter(function (i) { return i.variant_id !== freeCardVariantId; });
      var otherTotal = otherLines.reduce(function (sum, i) { return sum + i.final_line_price; }, 0);

      freeCardEl.hidden = cardLines.length > 0 || otherTotal <= 0;
      if (freeCardAddBtn) freeCardAddBtn.disabled = false;

      if (cardLines.length && !otherLines.length && !freeCardRemoving) {
        freeCardRemoving = true;
        var updates = {};
        cardLines.forEach(function (i) { updates[i.key] = 0; });
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates }),
        })
          .then(readCartResponse)
          .then(function (updated) {
            freeCardRemoving = false;
            renderCart(updated);
          })
          .catch(function () {
            freeCardRemoving = false;
            fetchCart();
          });
      }
    }

    if (freeCardAddBtn) {
      freeCardAddBtn.addEventListener('click', function () {
        freeCardAddBtn.disabled = true;
        clearError();
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: freeCardVariantId, quantity: 1 }),
        })
          .then(readCartResponse)
          .then(function () { return fetchCart(); })
          .catch(handleCartError)
          .then(function () { freeCardAddBtn.disabled = false; });
      });
    }

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    function clearError() {
      if (!errorEl) return;
      errorEl.textContent = '';
      errorEl.hidden = true;
    }

    // One cart mutation at a time. Without this, a second tap on a phone (where the
    // drawer takes a round-trip to respond) re-sends a line item key that the first
    // request already removed, and Shopify answers 422 "updates parameter is invalid."
    function beginCartRequest(row) {
      if (cartRequestInFlight) return false;
      cartRequestInFlight = true;
      itemsEl.setAttribute('aria-busy', 'true');
      itemsEl.querySelectorAll('.cart-drawer-item__step, .cart-drawer-item__remove')
        .forEach(function (btn) { btn.disabled = true; });
      // Mark the specific line the shopper touched so the spinner appears there
      // rather than on the whole drawer.
      if (row) row.classList.add('is-busy');
      return true;
    }

    function endCartRequest() {
      cartRequestInFlight = false;
      itemsEl.removeAttribute('aria-busy');
      // renderCart normally rebuilds these enabled; re-enable anyway in case a
      // re-sync failed and the old rows are still on screen.
      itemsEl.querySelectorAll('.cart-drawer-item__step, .cart-drawer-item__remove')
        .forEach(function (btn) { btn.disabled = false; });
      itemsEl.querySelectorAll('.cart-drawer-item.is-busy')
        .forEach(function (r) { r.classList.remove('is-busy'); });
    }

    // /cart/*.js returns 4xx with {status, message, description} instead of a cart.
    // Reject on those so they never reach renderCart, and surface Shopify's message.
    function readCartResponse(res) {
      return res
        .json()
        .catch(function () { return {}; })
        .then(function (body) {
          if (res.ok) return body;
          return Promise.reject(body);
        });
    }

    function handleCartError(err) {
      // Only trust the text when it is Shopify's {status, message, description}
      // error shape; anything else (network failure, HTML 5xx) gets the generic copy.
      var isShopifyError = err && typeof err === 'object' && err.status;
      var text = isShopifyError && (err.description || err.message);
      // Some Shopify cart errors are developer-facing ("updates parameter is
      // invalid."). Those must never reach a shopper - fall back to our own copy.
      if (text && /(parameter|invalid|required|expected|json)/i.test(text)) text = null;
      showError(text || defaultCartError);
      // The server-side cart is unchanged; re-sync so the drawer reflects reality.
      return fetchCart();
    }

    function renderCart(cart) {
      if (!cart || !Array.isArray(cart.items)) return;
      currentCart = cart;
      itemsEl.innerHTML = '';

      if (cart.item_count === 0) {
        emptyEl.hidden = false;
        footerEl.hidden = true;
        // Don't advertise an offer ladder over an empty cart.
        if (progressEl) progressEl.hidden = true;
        if (recommendationsEl) recommendationsEl.hidden = true;
        lastRecommendationsKey = null;
        pendingRecommendationItems = null;
      } else {
        emptyEl.hidden = true;
        footerEl.hidden = false;

        cart.items.forEach(function (item) {
          var node = template.content.cloneNode(true);
          var imageLink = node.querySelector('.cart-drawer-item__image');
          var img = node.querySelector('.cart-drawer-item__image img');
          var titleLink = node.querySelector('.cart-drawer-item__title');
          var variantEl = node.querySelector('.cart-drawer-item__variant');
          var priceEl = node.querySelector('.cart-drawer-item__price');
          var qtyEl = node.querySelector('.cart-drawer-item__qty');
          var stepBtns = node.querySelectorAll('.cart-drawer-item__step');
          var removeBtn = node.querySelector('.cart-drawer-item__remove');
          var row = node.querySelector('.cart-drawer-item');

          row.setAttribute('data-key', item.key);
          imageLink.href = item.url;
          if (item.image) {
            img.src = item.image;
            img.alt = item.product_title;
          }
          titleLink.href = item.url;
          titleLink.textContent = item.product_title;
          if (item.properties && item.properties['Purchased For']) {
            variantEl.textContent = certificateForTemplate.replace('__TITLE__', item.properties['Purchased For']);
          } else {
            variantEl.textContent = item.variant_title || '';
          }
          window.SolacelyMoney.render(priceEl, item.final_line_price);
          qtyEl.textContent = item.quantity;

          stepBtns.forEach(function (btn) {
            btn.addEventListener('click', function () {
              var delta = parseInt(btn.getAttribute('data-step'), 10);
              var newQty = item.quantity + delta;
              if (newQty <= 0) {
                removeLineItem(cart, item, row);
              } else {
                changeItem(item.key, newQty, row);
              }
            });
          });

          removeBtn.addEventListener('click', function () {
            removeLineItem(cart, item, row);
          });

          itemsEl.appendChild(node);
        });

        renderRecommendations(cart.items);
      }

      renderFreeCard(cart);

      window.SolacelyMoney.render(subtotalEl, cart.total_price);
      if (countEl) countEl.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
      // renderProgress un-hides progressEl on its first line, so it must not run
      // at all on an empty cart - hiding it above would be undone here.
      if (cart.item_count > 0) renderProgress(cart.total_price);

      var badge = document.querySelector('.nav__cart-badge');
      var cartIcons = document.querySelectorAll('[data-cart-drawer-toggle]');
      if (cart.item_count > 0) {
        if (!badge) {
          cartIcons.forEach(function (icon) {
            var span = document.createElement('span');
            span.className = 'nav__cart-badge';
            span.setAttribute('aria-hidden', 'true');
            icon.appendChild(span);
          });
          badge = document.querySelector('.nav__cart-badge');
        }
        document.querySelectorAll('.nav__cart-badge').forEach(function (b) {
          b.textContent = cart.item_count;
        });
      } else if (badge) {
        document.querySelectorAll('.nav__cart-badge').forEach(function (b) { b.remove(); });
      }
    }

    function fetchCart() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          renderCart(cart);
          return cart;
        })
        .catch(function () { /* keep the last good render; never rethrow into handleCartError */ });
    }

    function changeItem(key, quantity, row) {
      if (!beginCartRequest(row)) return Promise.resolve();
      clearError();
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity }),
      })
        .then(readCartResponse)
        .then(renderCart)
        .catch(handleCartError)
        .then(endCartRequest, endCartRequest);
    }

    function findLinkedCertificateKeys(cartSnapshot, variantId) {
      return cartSnapshot.items
        .filter(function (i) {
          return i.properties && i.properties['_certificate_for_variant'] == variantId;
        })
        .map(function (i) { return i.key; });
    }

    function removeLineItem(cartSnapshot, item, row) {
      var snapshot = currentCart || cartSnapshot;
      var liveKeys = snapshot.items.map(function (i) { return i.key; });
      var updates = {};

      // Shopify rejects the whole payload with "updates parameter is invalid." if any
      // key no longer exists, so only ask to remove lines that are still in the cart.
      [item.key].concat(findLinkedCertificateKeys(snapshot, item.variant_id))
        .forEach(function (key) {
          if (liveKeys.indexOf(key) !== -1) updates[key] = 0;
        });

      // Already gone (double tap, or removed in another tab) - just re-sync.
      if (!Object.keys(updates).length) return fetchCart();

      if (!beginCartRequest(row)) return Promise.resolve();
      clearError();
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates }),
      })
        .then(readCartResponse)
        .then(renderCart)
        .catch(handleCartError)
        .then(endCartRequest, endCartRequest);
    }

    function addItem(form) {
      var formData = new FormData(form);
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      })
        .then(function (res) {
          if (!res.ok) return Promise.reject(res);
          return fetchCart();
        })
        .then(openDrawer);
    }

    document.querySelectorAll('[data-cart-drawer-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        fetchCart().then(openDrawer);
      });
    });

    var checkoutBtn = drawer.querySelector('[data-cart-drawer-checkout]');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function () {
        // Do not preventDefault - let the navigation proceed; just show it started.
        checkoutBtn.classList.add('is-loading');
        checkoutBtn.setAttribute('aria-busy', 'true');
      });
      // Restore on back-navigation, including from the bfcache.
      window.addEventListener('pageshow', function () {
        checkoutBtn.classList.remove('is-loading');
        checkoutBtn.removeAttribute('aria-busy');
      });
    }

    // The X, the empty-state button and the footer link all carry the hook.
    // All are static markup, so a single query at init is enough.
    drawer.querySelectorAll('[data-cart-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', closeDrawer);
    });
    backdrop.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    // Swipe right to dismiss. Touch events rather than Pointer events + a
    // touch-action rule, because touch-action on .cart-drawer would have to
    // fight the horizontally scrolling recommendations rail nested inside it.
    (function () {
      var startX = 0, startY = 0, startT = 0, dx = 0;
      var tracking = false, dragging = false;

      drawer.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        if (!drawer.classList.contains('is-open')) return;
        // Let the recommendations rail own its own horizontal gestures.
        if (e.target.closest && e.target.closest('.cart-drawer__recommendations-list')) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        startT = Date.now();
        dx = 0;
        tracking = true;
        dragging = false;
      }, { passive: true });

      drawer.addEventListener('touchmove', function (e) {
        if (!tracking) return;
        var x = e.touches[0].clientX - startX;
        var y = e.touches[0].clientY - startY;
        if (!dragging) {
          // First move decides the axis. Vertical wins so the items list keeps scrolling.
          if (Math.abs(y) > Math.abs(x)) { tracking = false; return; }
          if (x < 8) return;
          dragging = true;
          drawer.style.transition = 'none';
        }
        dx = Math.max(0, x);
        e.preventDefault();
        drawer.style.transform = 'translateX(' + dx + 'px)';
      }, { passive: false });

      function endSwipe() {
        if (!tracking) return;
        tracking = false;
        if (!dragging) return;
        dragging = false;
        drawer.style.transition = '';
        var velocity = dx / Math.max(1, Date.now() - startT);
        var shouldClose = dx > drawer.offsetWidth * 0.3 || velocity > 0.5;
        // Hand control back to the .is-open class so its transition animates the close.
        drawer.style.transform = '';
        if (shouldClose) closeDrawer();
      }

      drawer.addEventListener('touchend', endSwipe);
      drawer.addEventListener('touchcancel', endSwipe);
    })();

    document.querySelectorAll('[data-cart-add-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addItem(form);
      });
    });

    document.addEventListener('solacely:cart-updated', function () {
      fetchCart().then(openDrawer);
    });

    fetchCart();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["solacely-predictive-search"] && !Shopify.designMode) return;
  try {
    (function () {
    var backdrop = document.getElementById('search-modal-backdrop');
    var modal = document.getElementById('search-modal');
    var closeBtn = document.getElementById('search-modal-close');
    var input = document.getElementById('search-modal-input');
    var resultsEl = document.getElementById('search-modal-results');
    var recommendationsEl = document.getElementById('search-modal-recommendations');

    if (!modal || !backdrop || !input) return;

    var predictiveSearchUrl = modal.dataset.predictiveSearchUrl;
    var abortController = null;
    var debounceTimer = null;

    function openModal() {
      modal.classList.add('is-open');
      backdrop.classList.add('is-visible');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (input.value.trim().length < 2) showRecommendations();
      window.setTimeout(function () { input.focus(); }, 50);
    }

    function closeModal() {
      modal.classList.remove('is-open');
      backdrop.classList.remove('is-visible');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function showRecommendations() {
      if (recommendationsEl) recommendationsEl.hidden = false;
      resultsEl.hidden = true;
    }

    function showResults() {
      if (recommendationsEl) recommendationsEl.hidden = true;
      resultsEl.hidden = false;
    }

    function fetchResults(term) {
      if (abortController) abortController.abort();
      abortController = new AbortController();

      fetch(predictiveSearchUrl + '?q=' + encodeURIComponent(term) + '&section_id=solacely-predictive-search-results', {
        signal: abortController.signal,
      })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.getElementById('search-modal-results-inner');
          resultsEl.innerHTML = inner ? inner.innerHTML : '';
          showResults();
        })
        .catch(function (err) {
          if (err.name !== 'AbortError') {
            resultsEl.innerHTML = '';
            showRecommendations();
          }
        });
    }

    function search(term) {
      window.clearTimeout(debounceTimer);

      if (term.length < 2) {
        resultsEl.innerHTML = '';
        showRecommendations();
        return;
      }

      debounceTimer = window.setTimeout(function () {
        fetchResults(term);
      }, 250);
    }

    document.querySelectorAll('[data-search-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        openModal();
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    backdrop.addEventListener('click', closeModal);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    input.addEventListener('input', function () {
      search(input.value.trim());
    });

    if (recommendationsEl) {
      recommendationsEl.querySelectorAll('[data-search-term]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var term = btn.getAttribute('data-search-term');
          input.value = term;
          input.focus();
          search(term);
        });
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["solacely-product-buy-box"] && !Shopify.designMode) return;
  try {
    (function () {
    var wrap = document.querySelector('.pdp-buy');
    if (!wrap) return;

    var product = JSON.parse(wrap.dataset.productJson);
    var form = wrap.querySelector('.pdp-buy__form');
    var idInput = wrap.querySelector('.pdp-buy__variant-id');
    var qtyInput = wrap.querySelector('.pdp-buy__quantity-input');
    var qtyNum = wrap.querySelector('.qv__qty-num');
    var atc = wrap.querySelector('.pdp-buy__atc');
    var unavailable = wrap.querySelector('.pdp-buy__unavailable');
    var addonInput = wrap.querySelector('.pdp-buy__addon-input');
    var priceEl = document.getElementById('sp-price');
    var quantity = 1;

    var currentVariant = product.variants.find(function (v) { return v.id === Number(idInput.value); });
    var selectedValues = currentVariant ? currentVariant.options.slice() : [];

    if (currentVariant) {
      currentVariant.product_id = product.id;
      console.log('[solacely-debug] initial load, syncing gallery to current variant', currentVariant);
      document.dispatchEvent(new CustomEvent('solacely:variant-changed', {
        detail: { variant: currentVariant, available: currentVariant.available },
      }));
    }

    // updateOptionAvailability is defined below updateVariantState but
    // hoisted (function declaration), so this initial call is safe here.
    updateOptionAvailability();
    updateFitPrices();

    // A price as HTML in the shop's own money_format - the markup and string
    // shape the currency converter recognises. Intl.NumberFormat output in
    // Shopify.currency.active (the store's base currency) was invisible to it.
    function moneyHTML(cents) {
      return window.SolacelyMoney.markup(cents);
    }

    function updateOptionAvailability() {
      if (!window.SolacelyVariantPicker) return;
      wrap.querySelectorAll('.sp__opt-btn').forEach(function (btn) {
        var index = Number(btn.getAttribute('data-option-index'));
        var value = btn.getAttribute('data-value');
        var available = window.SolacelyVariantPicker.isValueAvailable(product, selectedValues, index, value);
        btn.classList.toggle('sp__opt-btn--unavailable', !available);
      });
    }

    // Each Fit card shows the price of the variant you'd land on by picking
    // that fit while keeping the rest of the current selection, so the cards
    // re-price whenever any other option changes.
    function updateFitPrices() {
      wrap.querySelectorAll('.sp__fit-card').forEach(function (card) {
        var priceEl = card.querySelector('[data-fit-price]');
        if (!priceEl) return;

        var index = Number(card.getAttribute('data-option-index'));
        var value = card.getAttribute('data-value');
        var candidate = selectedValues.slice();
        candidate[index] = value;

        var variant = null;
        if (window.SolacelyVariantPicker) {
          variant = window.SolacelyVariantPicker.findVariant(product, candidate);
        }
        if (!variant) {
          variant = product.variants.find(function (v) { return v.options[index] === value; });
        }

        if (variant) {
          window.SolacelyMoney.render(priceEl, variant.price);
        } else {
          priceEl.textContent = '';
        }
      });
    }

    function updateVariantState() {
      updateOptionAvailability();
      updateFitPrices();

      var variant = window.SolacelyVariantPicker.findVariant(product, selectedValues);
      console.log('[solacely-debug] selectedValues:', selectedValues.slice(), 'matched variant:', variant);
      if (!variant) {
        console.log('[solacely-debug] no variant matched selectedValues, aborting update');
        return;
      }
      variant.product_id = product.id;

      idInput.value = variant.id;

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }

      var available = variant.available;
      unavailable.hidden = !!available;
      atc.disabled = !available;
      atc.textContent = available ? wrap.dataset.addToCartText : wrap.dataset.soldOutText;

      if (priceEl) {
        if (variant.compare_at_price > variant.price) {
          priceEl.innerHTML =
            '<span class="sp__price--sale">' + moneyHTML(variant.price) + '</span>' +
            '<span class="sp__price--compare">' + moneyHTML(variant.compare_at_price) + '</span>';
          window.SolacelyMoney.refresh(priceEl);
        } else {
          window.SolacelyMoney.render(priceEl, variant.price);
        }
      }

      console.log('[solacely-debug] dispatching solacely:variant-changed', {
        variant_id: variant.id,
        product_id: variant.product_id,
        featured_image: variant.featured_image,
        featured_media: variant.featured_media,
      });

      document.dispatchEvent(new CustomEvent('solacely:variant-changed', {
        detail: { variant: variant, available: available },
      }));
    }

    wrap.querySelectorAll('.sp__opt-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = Number(btn.getAttribute('data-option-index'));
        var value = btn.getAttribute('data-value');
        var display = btn.getAttribute('data-display') || value;
        selectedValues[index] = value;

        btn.closest('.qv-btn-grid').querySelectorAll('.sp__opt-btn').forEach(function (b) {
          b.classList.remove('qv-btn--active', 'sp__size-btn--active', 'sp__charm-swatch--active', 'sp__fit-card--active');
          if (b.classList.contains('sp__fit-card')) b.setAttribute('aria-pressed', 'false');
        });
        if (btn.classList.contains('sp__charm-swatch')) {
          btn.classList.add('sp__charm-swatch--active');
        } else if (btn.classList.contains('sp__fit-card')) {
          btn.classList.add('sp__fit-card--active');
          btn.setAttribute('aria-pressed', 'true');
        } else {
          btn.classList.add('qv-btn--active', 'sp__size-btn--active');
        }

        var valEl = wrap.querySelector('.sp__opt-val[data-option-value-index="' + index + '"]');
        if (valEl) valEl.textContent = display;

        updateVariantState();
      });
    });

    var qtyDec = wrap.querySelector('.qv__qty-dec');
    var qtyInc = wrap.querySelector('.qv__qty-inc');
    if (qtyDec) {
      qtyDec.addEventListener('click', function () {
        quantity = Math.max(1, quantity - 1);
        qtyNum.textContent = quantity;
        qtyInput.value = quantity;
      });
    }
    if (qtyInc) {
      qtyInc.addEventListener('click', function () {
        quantity += 1;
        qtyNum.textContent = quantity;
        qtyInput.value = quantity;
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var items = [{ id: Number(idInput.value), quantity: Number(qtyInput.value) }];
        if (addonInput && addonInput.checked && addonInput.dataset.addonVariantId) {
          items.push({
            id: Number(addonInput.dataset.addonVariantId),
            quantity: 1,
            properties: {
              '_certificate_for_variant': idInput.value,
              'Purchased For': product.title,
            },
          });
        }

        atc.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items }),
        })
          .then(function (res) {
            if (!res.ok) return Promise.reject(res);
            document.dispatchEvent(new CustomEvent('solacely:cart-updated'));
          })
          .catch(function () {
            form.submit();
          })
          .then(updateVariantState);
      });
    }

    var sizeGuideDrawer = document.getElementById('size-guide-drawer');
    var sizeGuideBackdrop = document.getElementById('size-guide-backdrop');
    var sizeGuideClose = document.getElementById('size-guide-drawer-close');

    if (sizeGuideDrawer && sizeGuideBackdrop) {
      var openSizeGuide = function () {
        sizeGuideDrawer.classList.add('is-open');
        sizeGuideBackdrop.classList.add('is-visible');
        sizeGuideDrawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        if (sizeGuideClose) sizeGuideClose.focus();
      };

      var closeSizeGuide = function () {
        sizeGuideDrawer.classList.remove('is-open');
        sizeGuideBackdrop.classList.remove('is-visible');
        sizeGuideDrawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      };

      wrap.querySelectorAll('[data-size-guide-trigger]').forEach(function (trigger) {
        trigger.addEventListener('click', openSizeGuide);
      });

      if (sizeGuideClose) sizeGuideClose.addEventListener('click', closeSizeGuide);
      sizeGuideBackdrop.addEventListener('click', closeSizeGuide);

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && sizeGuideDrawer.classList.contains('is-open')) closeSizeGuide();
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["solacely-product-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('.sp__track').forEach(function (track) {
      var viewer = track.closest('.sp__viewer');
      var wrap = viewer.closest('.sp__gallery');
      var slides = track.querySelectorAll('.sp__slide');
      var thumbs = wrap.querySelectorAll('[data-sp-thumbs] .sp__thumb');
      var cur = 0;
      slides.forEach(function (slide, i) {
        if (slide.classList.contains('sp__slide--active')) cur = i;
      });

      function goTo(n) {
        slides[cur].classList.remove('sp__slide--active');
        if (thumbs[cur]) thumbs[cur].classList.remove('sp__thumb--active');
        cur = (n + slides.length) % slides.length;
        slides[cur].classList.add('sp__slide--active');
        if (thumbs[cur]) {
          thumbs[cur].classList.add('sp__thumb--active');
          thumbs[cur].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      }

      var prev = viewer.querySelector('[data-sp-prev]');
      var next = viewer.querySelector('[data-sp-next]');
      if (prev) prev.addEventListener('click', function () { goTo(cur - 1); });
      if (next) next.addEventListener('click', function () { goTo(cur + 1); });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { goTo(+t.dataset.index); });
      });

      document.addEventListener('solacely:variant-changed', function (e) {
        var variant = e.detail && e.detail.variant;
        if (!variant || !variant.featured_media) return;
        if (String(variant.product_id) !== wrap.dataset.productId) return;

        var index = -1;
        slides.forEach(function (slide, i) {
          if (+slide.dataset.mediaId === variant.featured_media.id) index = i;
        });
        if (index > -1) goTo(index);
      });

      track.querySelectorAll('[data-sp-video-poster]').forEach(function (poster) {
        poster.addEventListener('click', function () {
          var slide = poster.closest('.sp__slide');
          var embed = slide.querySelector('[data-sp-video-embed]');
          var tpl = slide.querySelector('[data-sp-video-template]');
          if (tpl) {
            embed.appendChild(tpl.content.cloneNode(true));
            tpl.remove();
          }
          embed.hidden = false;
          poster.remove();
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["solacely-product-recommendations"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('.product-recs[data-product-id]').forEach(function (section) {
      var productId = section.dataset.productId;
      var limit = parseInt(section.dataset.limit, 10) || 4;
      var grid = section.querySelector('.product-recs__grid');
      if (!grid) return;

      fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + limit + '&intent=related')
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (data) {
          if (!data || !data.products || !data.products.length) return;

          return Promise.all(
            data.products.map(function (recommendedProduct) {
              return fetch('/products/' + recommendedProduct.handle + '?view=solacely-card')
                .then(function (res) { return res.ok ? res.text() : null; })
                .catch(function () { return null; });
            })
          ).then(function (htmlFragments) {
            htmlFragments.filter(Boolean).forEach(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var card = doc.querySelector('.card');
              if (card) grid.appendChild(card);
            });

            if (grid.children.length) {
              section.hidden = false;
            }
          });
        })
        .catch(function () {});
    });
  }());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["solacely-quick-view"] && !Shopify.designMode) return;
  try {
    (function () {
    var backdrop = document.getElementById('quick-view-backdrop');
    var modal = document.getElementById('quick-view');
    var closeBtn = document.getElementById('quick-view-close');
    var body = document.getElementById('quick-view-body');
    var template = document.getElementById('quick-view-template');
    var optionTemplate = document.getElementById('qv-option-template');

    if (!modal || !backdrop || !template || !optionTemplate) return;

    var currentProduct = null;
    var selectedValues = [];
    var quantity = 1;

    function openModal() {
      modal.classList.add('is-open');
      backdrop.classList.add('is-visible');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }

    function closeModal() {
      modal.classList.remove('is-open');
      backdrop.classList.remove('is-visible');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      body.innerHTML = '';
      currentProduct = null;
    }

    function renderProduct(product) {
      currentProduct = product;
      var defaultVariant = product.variants.find(function (v) { return v.available; }) || product.variants[0];
      selectedValues = defaultVariant.options.slice();
      quantity = 1;

      body.innerHTML = '';
      var node = template.content.cloneNode(true);
      var img = node.querySelector('.qv__img');
      var title = node.querySelector('.qv__title');
      var optionsEl = node.querySelector('.qv__options');
      var qtyNum = node.querySelector('.qv__qty-num');
      var atc = node.querySelector('.qv__atc');

      title.textContent = product.title;
      if (product.featured_image) {
        img.src = product.featured_image;
        img.alt = product.title;
      }

      product.options.forEach(function (option, index) {
        var optNode = optionTemplate.content.cloneNode(true);
        var optName = optNode.querySelector('.qv-opt-name');
        var grid = optNode.querySelector('.qv-btn-grid');

        optName.textContent = (option && typeof option === 'object') ? option.name : option;

        window.SolacelyVariantPicker.optionValues(product, index).forEach(function (value) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'qv-btn';
          btn.textContent = value;
          btn.setAttribute('data-option-index', index);
          btn.setAttribute('data-value', value);
          if (selectedValues[index] === value) btn.classList.add('qv-btn--active');

          btn.addEventListener('click', function () {
            selectedValues[index] = value;
            grid.querySelectorAll('.qv-btn').forEach(function (b) { b.classList.remove('qv-btn--active'); });
            btn.classList.add('qv-btn--active');
            updateVariantState(body);
          });

          grid.appendChild(btn);
        });

        optionsEl.appendChild(optNode);
      });

      node.querySelector('.qv__qty-dec').addEventListener('click', function () {
        quantity = Math.max(1, quantity - 1);
        qtyNum.textContent = quantity;
      });
      node.querySelector('.qv__qty-inc').addEventListener('click', function () {
        quantity += 1;
        qtyNum.textContent = quantity;
      });

      atc.addEventListener('click', function () {
        var variant = window.SolacelyVariantPicker.findVariant(currentProduct, selectedValues);
        if (!variant || !variant.available) return;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variant.id, quantity: quantity }),
        })
          .then(function (res) {
            if (!res.ok) return Promise.reject(res);
            closeModal();
            document.dispatchEvent(new CustomEvent('solacely:cart-updated'));
          });
      });

      body.appendChild(node);
      updateVariantState(body);
    }

    function updateVariantState(scope) {
      scope.querySelectorAll('.qv-btn').forEach(function (btn) {
        var index = Number(btn.getAttribute('data-option-index'));
        var value = btn.getAttribute('data-value');
        var available = window.SolacelyVariantPicker.isValueAvailable(currentProduct, selectedValues, index, value);
        btn.classList.toggle('qv-btn--unavailable', !available);
      });

      var variant = window.SolacelyVariantPicker.findVariant(currentProduct, selectedValues);
      var priceCurrent = scope.querySelector('.qv__price-current');
      var priceCompare = scope.querySelector('.qv__price-compare');
      var unavailable = scope.querySelector('.qv__unavailable');
      var atc = scope.querySelector('.qv__atc');
      var img = scope.querySelector('.qv__img');

      if (variant) {
        // Rendered as `<span class="money">` in the shop's money_format so the
        // currency converter can find and convert it (see snippets/solacely-money).
        window.SolacelyMoney.render(priceCurrent, variant.price);
        if (variant.compare_at_price > variant.price) {
          window.SolacelyMoney.render(priceCompare, variant.compare_at_price);
        } else {
          priceCompare.textContent = '';
        }
        if (img && variant.featured_image) {
          img.src = variant.featured_image.src || variant.featured_image;
          img.alt = currentProduct.title;
        }
      }

      var available = variant && variant.available;
      unavailable.hidden = !!available;
      atc.disabled = !available;
      atc.textContent = available ? modal.dataset.addToCartText : modal.dataset.soldOutText;
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-quick-view-trigger]');
      if (!trigger) return;
      e.preventDefault();
      var handle = trigger.getAttribute('data-product-handle');
      if (!handle) return;

      fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (product) {
          renderProduct(product);
          openModal();
        });
    });

    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    backdrop.addEventListener('click', closeModal);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["solacely-sticky-atc"] && !Shopify.designMode) return;
  try {
    (function () {
    var sticky = document.getElementById('sticky-atc');
    var target = document.querySelector('.pdp-buy__atc');
    if (!sticky || !target) return;

    var stickyBtn = document.getElementById('sticky-atc-btn');
    var stickyPrice = document.getElementById('sticky-atc-price');
    var stickyVariant = document.getElementById('sticky-atc-variant');

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var pastButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', pastButton);
          sticky.setAttribute('aria-hidden', pastButton ? 'false' : 'true');
        });
      }, { threshold: 0 });
      observer.observe(target);
    }

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        target.click();
      });
    }

    document.addEventListener('solacely:variant-changed', function (e) {
      var variant = e.detail.variant;
      var available = e.detail.available;

      stickyBtn.disabled = !available;
      stickyBtn.textContent = target.textContent.trim();

      if (stickyVariant && variant.title) {
        stickyVariant.textContent = variant.title.replace(/ \/ /g, ' · ').toUpperCase();
      }

      if (stickyPrice) {
        stickyPrice.innerHTML = document.getElementById('sp-price') ? document.getElementById('sp-price').innerHTML : stickyPrice.innerHTML;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["solacely-wishlist-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    var STORAGE_KEY = 'solacely_wishlist';

    var backdrop = document.getElementById('wishlist-drawer-backdrop');
    var drawer = document.getElementById('wishlist-drawer');
    var closeBtn = document.getElementById('wishlist-drawer-close');
    var itemsEl = document.getElementById('wishlist-drawer-items');
    var emptyEl = document.getElementById('wishlist-drawer-empty');
    var countEl = document.getElementById('wishlist-drawer-count');
    var template = document.getElementById('wishlist-drawer-item-template');

    if (!drawer || !backdrop || !template) return;

    var i18n = {
      add: drawer.getAttribute('data-i18n-add'),
      remove: drawer.getAttribute('data-i18n-remove'),
      moveToCart: drawer.getAttribute('data-i18n-move-to-cart'),
      chooseOptions: drawer.getAttribute('data-i18n-choose-options'),
      soldOut: drawer.getAttribute('data-i18n-sold-out'),
    };

    var productCache = {};

    function getWishlist() {
      try {
        return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      } catch (e) {
        return [];
      }
    }

    function setWishlist(handles) {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
      syncButtons();
      updateBadge();
    }

    function isWishlisted(handle) {
      return getWishlist().indexOf(handle) !== -1;
    }

    function toggleWishlist(handle) {
      var handles = getWishlist();
      var index = handles.indexOf(handle);
      if (index === -1) {
        handles.push(handle);
      } else {
        handles.splice(index, 1);
      }
      setWishlist(handles);
      if (drawer.classList.contains('is-open')) renderDrawer();
    }

    function syncButtons() {
      var handles = getWishlist();
      document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
        var handle = btn.getAttribute('data-product-handle');
        var active = handles.indexOf(handle) !== -1;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        btn.setAttribute('aria-label', active ? i18n.remove : i18n.add);
      });
    }

    function updateBadge() {
      var count = getWishlist().length;
      var toggles = document.querySelectorAll('[data-wishlist-drawer-toggle]');
      var existingBadge = document.querySelector('.nav__wishlist-badge');

      if (count > 0) {
        if (!existingBadge) {
          toggles.forEach(function (toggle) {
            var span = document.createElement('span');
            span.className = 'nav__wishlist-badge';
            span.setAttribute('aria-hidden', 'true');
            toggle.appendChild(span);
          });
        }
        document.querySelectorAll('.nav__wishlist-badge').forEach(function (badge) {
          badge.textContent = count;
        });
      } else if (existingBadge) {
        document.querySelectorAll('.nav__wishlist-badge').forEach(function (badge) { badge.remove(); });
      }

      if (countEl) countEl.textContent = count > 0 ? '(' + count + ')' : '';
    }

    function fetchProduct(handle) {
      if (productCache[handle]) return Promise.resolve(productCache[handle]);
      return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (product) {
          if (product) productCache[handle] = product;
          return product;
        })
        .catch(function () { return null; });
    }

    function openDrawer() {
      renderDrawer();
      drawer.classList.add('is-open');
      backdrop.classList.add('is-visible');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
      // Converters skip hidden nodes on their first pass - re-scan on open.
      window.SolacelyMoney.refresh(drawer);
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      backdrop.classList.remove('is-visible');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function renderDrawer() {
      var handles = getWishlist();

      if (!handles.length) {
        itemsEl.innerHTML = '';
        emptyEl.hidden = false;
        updateBadge();
        return;
      }

      emptyEl.hidden = true;

      Promise.all(handles.map(fetchProduct)).then(function (products) {
        itemsEl.innerHTML = '';

        handles.forEach(function (handle, index) {
          var product = products[index];
          if (!product) return;

          var node = template.content.cloneNode(true);
          var row = node.querySelector('.wishlist-drawer-item');
          var imageLink = node.querySelector('.wishlist-drawer-item__image');
          var img = imageLink.querySelector('img');
          var titleLink = node.querySelector('.wishlist-drawer-item__title');
          var priceEl = node.querySelector('.wishlist-drawer-item__price');
          var actionBtn = node.querySelector('.wishlist-drawer-item__action');
          var removeBtn = node.querySelector('.wishlist-drawer-item__remove');

          row.setAttribute('data-handle', handle);
          imageLink.href = product.url;
          titleLink.href = product.url;
          titleLink.textContent = product.title;
          if (product.featured_image) {
            img.src = product.featured_image;
            img.alt = product.title;
          }
          // `<span class="money">` in the shop's money_format so the currency
          // converter can find and convert it (see snippets/solacely-money).
          window.SolacelyMoney.render(priceEl, product.price);

          var availableVariant = (product.variants || []).find(function (v) { return v.available; });

          if (product.variants && product.variants.length > 1) {
            actionBtn.textContent = i18n.chooseOptions;
            actionBtn.setAttribute('data-quick-view-trigger', '');
            actionBtn.setAttribute('data-product-handle', handle);
            if (!availableVariant) actionBtn.disabled = true;
          } else if (availableVariant) {
            actionBtn.textContent = i18n.moveToCart;
            actionBtn.addEventListener('click', function () {
              actionBtn.disabled = true;
              fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ id: availableVariant.id, quantity: 1 }),
              })
                .then(function (res) {
                  if (!res.ok) return Promise.reject(res);
                  var updatedHandles = getWishlist().filter(function (h) { return h !== handle; });
                  setWishlist(updatedHandles);
                  closeDrawer();
                  document.dispatchEvent(new CustomEvent('solacely:cart-updated'));
                })
                .catch(function () { actionBtn.disabled = false; });
            });
          } else {
            actionBtn.textContent = i18n.soldOut;
            actionBtn.disabled = true;
          }

          removeBtn.addEventListener('click', function () {
            var updatedHandles = getWishlist().filter(function (h) { return h !== handle; });
            setWishlist(updatedHandles);
            renderDrawer();
          });

          itemsEl.appendChild(node);
        });

        updateBadge();
      });
    }

    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-wishlist-toggle]');
      if (toggle) {
        e.preventDefault();
        toggleWishlist(toggle.getAttribute('data-product-handle'));
        return;
      }

      var drawerToggle = e.target.closest('[data-wishlist-drawer-toggle]');
      if (drawerToggle) {
        e.preventDefault();
        openDrawer();
      }
    });

    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    backdrop.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    syncButtons();
    updateBadge();
  })();
  } catch(e) { console.error(e); }
})();

})();
